import Navbar from './components/Navbar';
import './App.css';
import Home from "./components/Home"
import About from './components/About';
import Skills from './components/Skills';
import Project from './components/Project';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

function App() {
  return (
    <BrowserRouter>
    <Routes>
    <Route path='/' element={<Home/>}/> 
    <Route path='/about' element={<About/>}/> 
    <Route path='/skills' element={<Skills/>}/> 
    <Route path='/projects' element={<Project/>}/> 
    <Route path="*" element={<h1>Error Page</h1>} />
    </Routes>
    </BrowserRouter>
  );
}

export default App;
